const serviceImageManifest = {
  fireExtinguisher: [
    "/images/fire-extinguisher/automated-Fire-extinguisher.webp",
    "/images/fire-extinguisher/CO2-Fire-suppression-system.jpg",
    "/images/fire-extinguisher/co2-flooding-system-1000x1000.jpg",
  ],
  fireAlarmSystems: [
    "/images/Fire-Alarm-Systems/_nib3I4R4fVqaJEzQchVtKM4U5rpSLddk7tCeTie0KjNWIpD8va1zJUhKpOIH_qu3wv4m1ZP_pVDrd3pZOAZyhhhDPfheNDglZk4fzBjjmk.jpg",
    "/images/Fire-Alarm-Systems/08868231f4656718749a0fc523044041.jpg",
    "/images/Fire-Alarm-Systems/31Xl6DuIsOL._AC_UF894,1000_QL80_.jpg",
    "/images/Fire-Alarm-Systems/618cdfa3202b1d251c484e97_How%20Do%20Fire%20Alarms%20Work%20in%20Commercial%20Buildings.jpg",
    "/images/Fire-Alarm-Systems/6193a4b4110d24a5b2acc29c_Commercial%20Fire%20Alarm%20System%20Guide-min.jpg",
    "/images/Fire-Alarm-Systems/65f854814fd223fc3678f9a3_Addressable-Fire-Alarm-Systems.png",
    "/images/Fire-Alarm-Systems/6gX2PxQ0Vf-7tKkctiS63Bz0hKeeBvNfwIlUYqFrpOJl_LiEvCoy3pAnhn35_L9BWDu_GUet-nGbQgeyRSn5pX0iNvxQQ3AD4XQ_gjL-HrM.jpg",
    "/images/Fire-Alarm-Systems/71RigHRnQ+L._AC_UF894,1000_QL80_.jpg",
    "/images/Fire-Alarm-Systems/73pucaSHiGkbP7LRgaSIEPD8zGNTBX6x9XV_OyNFjVfTQG1QfW1t2hQ40T42LSZg0yFqldD90smiSfNslcCDXY2qcAT5yfPh-nOVDDfydwY.jpg",
    "/images/Fire-Alarm-Systems/8-red-fire-bell-200mm-24vdc.jpg",
    "/images/Fire-Alarm-Systems/8jt6FYUcp98D-LKAgX9uyI4c7KgmfrIL4jH2n9a01vHDua-hG-3hkxUnfSwqDzsP3Jj437Lib6-R3YdldV5t1Rn5cZopMJFfDd5Odd0bMWE.jpg",
    "/images/Fire-Alarm-Systems/Addressable-Fire-Alarm-Strobe-Sounder-Horn-Strobe-Flash-and-Sounder.avif",
    "/images/Fire-Alarm-Systems/blobid1743092385467.webp",
    "/images/Fire-Alarm-Systems/design-fire-alarm-system.png",
    "/images/Fire-Alarm-Systems/facilities-management-pipes-29818525.webp",
    "/images/Fire-Alarm-Systems/fUFzw39POCyFOBFaMLmMiPXCSt9CrSeJWo2vxEeEzIwSriyCYemK96TxmFTyYhP9OCWJ2jLGOpWI8YOBkj4PLnhOHMybkcNdr2V3zNqvloo.jpg",
    "/images/Fire-Alarm-Systems/hbt-fire-p1907192-300-series-photoelectric-smoke-detector-primaryimage.webp",
    "/images/Fire-Alarm-Systems/heat-alarm-5b64445c3d78b55f4dde06a0.jpg",
    "/images/Fire-Alarm-Systems/high%20hazard%20sprinkler%20systems.jpg",
    "/images/Fire-Alarm-Systems/image.png",
    "/images/Fire-Alarm-Systems/IMG_9806.webp",
    "/images/Fire-Alarm-Systems/pWEODWN6M3U8LIYnSavtsmhevCHQDT-LNek5wwXMN1d0qHghjg-R-WV8eu7xbKN2H4uWBQ809VC9HiVsKRGeSmgyuKKfR1x7ZSl87Tz7z4k.jpg",
    "/images/Fire-Alarm-Systems/types-of-fire-alarm.png",
  ],
  sprinklerSystem: [
    "/images/sprinkler_system/facilities-management-pipes-29818525.webp",
    "/images/sprinkler_system/Fire_sprinkler_roof_mount_side_view.jpg",
    "/images/sprinkler_system/high%20hazard%20sprinkler%20systems.jpg",
    "/images/sprinkler_system/pWEODWN6M3U8LIYnSavtsmhevCHQDT-LNek5wwXMN1d0qHghjg-R-WV8eu7xbKN2H4uWBQ809VC9HiVsKRGeSmgyuKKfR1x7ZSl87Tz7z4k%20(1).jpg",
    "/images/sprinkler_system/sprinkler-58e2afea5f9b58ef7eb86178.jpg",
    "/images/sprinkler_system/WhatsApp%20Image%202026-02-25%20at%207.44.58%20PM.jpeg",
    "/images/sprinkler_system/WhatsApp%20Image%202026-02-25%20at%207.45.09%20PM.jpeg",
    "/images/sprinkler_system/WhatsApp%20Image%202026-02-25%20at%207.45.10%20PM.jpeg",
    "/images/sprinkler_system/WhatsApp%20Image%202026-03-05%20at%207.47.57%20PM.jpeg",
    "/images/sprinkler_system/WhatsApp%20Image%202026-03-05%20at%207.47.59%20PM.jpeg",
    "/images/sprinkler_system/WhatsApp%20Image%202026-03-05%20at%207.48.00%20PM.jpeg",
    "/images/sprinkler_system/WhatsApp%20Image%202026-03-05%20at%207.48.01%20PM.jpeg",
    "/images/sprinkler_system/WhatsApp%20Image%202026-03-05%20at%207.48.02%20PM.jpeg",
  ],
  emergencyLights: [
    "/images/emergency-lights/3mDZADxjMAulmzrzYOOn9xHZSn4QVEwl41FESCKhECk7GlvfznL8xpQrBjj6YZvX-eHOBJA_QWPNVw_wkv0lI_IHJipVPdklUgWHd6NXeQw.jpg",
    "/images/emergency-lights/76yvHsMjxoXFU4WTt3JUP94YBWVObAz48gti09nzlKzkXU0iZueHb4nEzuD-Q8MeywZXladWrqsgsRcsVSs2v3F2K7aqdqMe1cmlK-fDSrw.jpg",
    "/images/emergency-lights/rKGpcdySuc5au8QGVXi18u_EsaETgbClI2bhlNPqBcHJijLk4Urzk6edYOB8N9St45-d46aD8HV3VJfqpH2Wk7O-mA4i73tE4kwMnO2rNPk.jpg",
    "/images/emergency-lights/VRRSsIdZ3Hrp7F-MiQX3BYUhkRJgyT6js3C-k3k9WT-p1szH9NKExmSOk1PuiKJGViwxnzYrzbX_9bZDpXRNYOuvDQlnvgGThdzaGhYL220.jpg",
    "/images/emergency-lights/WkM7Ecs0fbsLPqwSLpG_y-cimFLti-eKQMT9W0bIoIpwSlHsmGrJgMOWpQZhT4LVnJsQErzLdarPK5WiFH1sq-lzm9oVmP20IQSDwIsOE_U.jpg",
  ],
  fireSafetyTraining: [
    "/images/fire-safety-training/feuerloschubung_im_betrieb-cws_fire_safety.jpg",
    "/images/fire-safety-training/Fire%20Extinguisher%20Training%20Demo%20Open%20Burn.jpg",
    "/images/fire-safety-training/Fire_drill_in_a_smoke_trailer,_Naples,_Italy_-_081007-N-4044H-271.jpg",
    "/images/fire-safety-training/PASS-steps-as-shown-through-the-video-training-Bass-2014_Q320.jpg",
    "/images/fire-safety-training/Z_61FevxEdbNPF7t_FireSafetyPrevention.avif",
  ],
  complianceAudits: [
    "/images/complainces-and-audits/0_l7xz_e_0Y31BCplJ.png",
    "/images/complainces-and-audits/06c082721669e71c86cda1f8000022c610ef15a2-940x492.webp",
    "/images/complainces-and-audits/fire-and-life-safety-safety-inspection-checklist-sipe.jpg",
    "/images/complainces-and-audits/Guide%20to%20WHS%20Inspections-1.webp",
    "/images/complainces-and-audits/Industrial-buildings-2.jpg",
  ],
  oxygenCylinders: [
    "/images/ppes/ppes-oxygen-cylender/12L-1.jpg",
    "/images/ppes/ppes-oxygen-cylender/54034_w.webp",
    "/images/ppes/ppes-oxygen-cylender/Best-Price-Scba-Respiration-Cylinder-Respirator-for-Firefighter.avif",
    "/images/ppes/ppes-oxygen-cylender/breathing-apparatus-set-500x500.webp",
    "/images/ppes/ppes-oxygen-cylender/cylinder_final_red.webp",
    "/images/ppes/ppes-oxygen-cylender/Kl99-Firefighting-Respirator-60-Mins-Scba-with-6-8-Liter-Cylinder.avif",
    "/images/ppes/ppes-oxygen-cylender/Self-contained_breathing_apparatus.jpg",
  ],
  fabrication: [
    "/images/fabrication/WhatsApp%20Image%202026-02-25%20at%207.44.54%20PM.jpeg",
    "/images/fabrication/WhatsApp%20Image%202026-02-25%20at%207.44.56%20PM.jpeg",
    "/images/fabrication/WhatsApp%20Image%202026-02-25%20at%207.44.58%20PM.jpeg",
    "/images/fabrication/WhatsApp%20Image%202026-02-25%20at%207.50.22%20PM.jpeg",
    "/images/fabrication/WhatsApp%20Image%202026-02-25%20at%207.50.23%20PM.jpeg",
    "/images/fabrication/WhatsApp%20Image%202026-03-05%20at%207.47.55%20PM.jpeg",
    "/images/fabrication/WhatsApp%20Image%202026-03-05%20at%207.47.59%20PM.jpeg",
    "/images/fabrication/WhatsApp%20Image%202026-03-05%20at%207.48.00%20PM.jpeg",
  ],
  fireHydrantSystem: [
    "/images/fire_hydrant_system/Fire-Hydrant-4.jpg",
    "/images/fire_hydrant_system/fire-hydrant-systems-739.jpg",
    "/images/fire_hydrant_system/WhatsApp%20Image%202026-02-25%20at%207.44.59%20PM.jpeg",
    "/images/fire_hydrant_system/WhatsApp%20Image%202026-02-25%20at%207.48.56%20PM.jpeg",
    "/images/fire_hydrant_system/WhatsApp%20Image%202026-02-25%20at%207.50.23%20PM.jpeg",
  ],
  waterModularTank: [
    "/images/water_modular_tank/farm-grain-bin-builder11.jpg",
    "/images/water_modular_tank/IMG_2156-1024x768.jpg",
    "/images/water_modular_tank/larger-capacity-storage-tanks-1000x1000.jpg",
    "/images/water_modular_tank/Process-Water-Tanks-002-min.jpg",
    "/images/water_modular_tank/STP-Water-Tanks-003-min.jpg",
    "/images/water_modular_tank/WhatsApp%20Image%202026-03-05%20at%207.47.49%20PM.jpeg",
  ],
};

export default serviceImageManifest;
